import React, {Component} from 'react';
import {observer} from 'mobx-react';

import Field from 'lib/struct/form/fields/Field';
import IconBox from 'lib/struct/icon/IconBox';
import Icon from 'lib/struct/icon/Icon';
import Select from 'lib/struct/form/Select';

import c_styles from '../ProductGroupsSettingsComponent.less';

@observer export default class NewGroupSelect extends Component {
	render() {
		/** @type {ProductGroupsSettingsContext} */
		const context = this.props.context;

		return (
			<Field
				className='block not-padded bottom-padded'
				labelClassName={c_styles['field-label']}
				boxClassName={c_styles['field-box']}
			>
				<IconBox icon={<Icon name='add' />}>
					<Select
						disabled={context.available_groups.length === 0}
						options={context.available_groups_options}
						value=''
						onChange={e => context.addNewProductGroup(e.target.value)}
					/>
				</IconBox>
			</Field>
		);
	}
}